var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import get from 'lodash.get';
import set from 'lodash.set';
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener, CollapseEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isContentfulString, isDefined } from '@philips-internal/oswald-ui-utils';
import { FieldsetProperties } from './fieldset-types.js';
class FieldsetAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
        /** @event */
        this.onCollapse = new CollapseEventListener();
    }
    getSection() {
        return this.state.section ?? FieldsetProperties.section.defaultValue;
    }
    getTitle() {
        if (isContentfulString(this.getSection().title)) {
            return this.getSection().title;
        }
        return this.state.title;
    }
    setTitle(title) {
        this.setState({ section: { ...this.state.section, title } });
    }
    getEntry() {
        return this.state.entry ?? FieldsetProperties.entry.defaultValue;
    }
    setEntry(entry) {
        this.setState({ entry });
    }
    getData() {
        return this.state.data ?? FieldsetProperties.data.defaultValue;
    }
    setData(data) {
        this.setState({ data });
    }
    isVisible() {
        return this.state.visible ?? FieldsetProperties.visible.defaultValue;
    }
    setVisible(visible) {
        this.setState({ visible });
    }
    setVisibility(visibility) {
        this.setState({ visibility });
    }
    getVisibility() {
        return this.state.visibility ?? FieldsetProperties.visibility.defaultValue;
    }
    getValue() {
        const data = this.getData();
        const entry = this.getEntry();
        return get(data, entry);
    }
    setValue(value) {
        const data = this.getData();
        const entry = this.getEntry();
        const oldValue = get(data, entry);
        set(data, entry, value);
        this.setState({ data });
        this.onChange.fire({ entry, oldValue, value });
    }
    isCollapsible() {
        if (isDefined(this.getSection().showCollapseButton)) {
            return Boolean(this.getSection().showCollapseButton);
        }
        return Boolean(this.state.collapsible);
    }
    setCollapsible(collapsible) {
        this.setState({ section: { ...this.getSection(), showCollapseButton: collapsible } });
    }
    isCollapsed() {
        return this.refs.section.isCollapsed();
    }
    setCollapsed(collapsed) {
        this.refs.section.setCollapsed(collapsed);
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FieldsetAPI.prototype, "onChange", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FieldsetAPI.prototype, "onCollapse", void 0);
export { FieldsetAPI, };
//# sourceMappingURL=fieldset-api.js.map